




















import Vue from 'vue';
import NemiFooter from '@/components/partials/nemi-footer.vue';

export default Vue.extend({
  name: 'AuthenticationLayout',
  components: { NemiFooter, },
  data: () => ({
    logo: `${process.env.VUE_APP_LOGIN_LOGO}`,
    hostCompany: `${process.env.VUE_APP_COMPANY_HOST}`,
  }),
});
